import Crud from '../views/GrupoChecklist/Crud'
import Entity from '../views/GrupoChecklist/Add'

let routes = {
    path: '/groupchecklists',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/groupchecklists/add',
            name: 'NewGrupoChecklist',
            component: Entity
        },
        {
            path: '/groupchecklists/edit/:id?',
            name: 'EditGrupoChecklist',
            component: Entity
        },
        {
            path: '/groupchecklists',
            name: 'list-groupchecklists',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Grupos de Checklists',
                breadcrumb: [
                    {
                        text: 'Grupos de Checklists',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
